<div class="title">
    <fa-icon [icon]="faAngleRight"></fa-icon>
    <span>{{ 'Extension.Title' | translate }} {{ extensionInformations?.name ? (extensionInformations | extensionDisplay) : '' }}</span>
</div>

<mat-tab-group #extensionTab class="tab-group">
    <mat-tab label="Général" class="tab">
        @if (extensionInformations) {
        <app-extension-form [extension]="extensionInformations" [extensionsList]="extensionsList"></app-extension-form>
        }
    </mat-tab>
    @if (extensionInformations?.id && (extensionInformations.type === extensionTypes.user || extensionInformations.type === extensionTypes.group)) {
    <mat-tab label="Règles" class="tab">
        <div style="height: 100%; overflow: auto">
            <div>
                <app-extension-rules [extension]="extensionInformations" [extensionsList]="extensionsList"></app-extension-rules>
            </div>
            <div style="margin-top: 20px">
                <app-global-rules [isReadOnly]="true" [extensionsList]="extensionsList"></app-global-rules>
            </div>
        </div>
    </mat-tab>
    }
</mat-tab-group>
